(function () {
  if (window.OracleBookletSearch) {
    window.OracleBookletSearch.initAll();
    return;
  }

  var initializedDataListeners = new WeakSet();

  function normalize(value) {
    return String(value || '')
      .normalize('NFD')
      .replace(/[\u0300-\u036f]/g, '')
      .toLowerCase()
      .replace(/[-‐‑‒–—―]/g, ' ')
      .replace(/[^a-z0-9\s]/g, ' ')
      .replace(/\s+/g, ' ')
      .trim();
  }

  function isOneEditAway(a, b) {
    if (!a || !b || Math.abs(a.length - b.length) > 1 || a[0] !== b[0]) return false;
    var i = 0;
    var j = 0;
    var edits = 0;

    while (i < a.length && j < b.length) {
      if (a[i] === b[j]) {
        i += 1;
        j += 1;
        continue;
      }
      edits += 1;
      if (edits > 1) return false;
      if (a.length > b.length) i += 1;
      else if (b.length > a.length) j += 1;
      else {
        i += 1;
        j += 1;
      }
    }

    return edits + (i < a.length || j < b.length ? 1 : 0) <= 1;
  }

  function tokensMatch(query, candidate) {
    var queryTokens = query.split(' ').filter(Boolean);
    var candidateTokens = candidate.split(' ').filter(Boolean);
    if (!queryTokens.length) return true;

    return queryTokens.every(function (queryToken) {
      return candidateTokens.some(function (candidateToken) {
        if (candidateToken === queryToken || candidateToken.indexOf(queryToken) === 0) return true;
        return queryToken.length >= 4 && isOneEditAway(queryToken, candidateToken);
      });
    });
  }

  function fieldScore(query, candidate, weight) {
    if (!candidate) return 0;
    if (candidate === query) return weight + 400;
    if (candidate.indexOf(query) === 0) return weight + 300;
    if (candidate.indexOf(query) !== -1) return weight + 200;
    if (tokensMatch(query, candidate)) return weight + 100;
    return 0;
  }

  function createIndex(cards) {
    return cards.map(function (card) {
      return {
        card: card,
        name: normalize(card.nome),
        subtitle: normalize(card.subtitulo),
        keywords: normalize((card.palavrasChave || []).join(' ')),
        content: normalize(card.textoCompleto)
      };
    });
  }

  function scoreEntry(entry, query) {
    if (!query) return 1;
    return Math.max(
      fieldScore(query, entry.name, 4000),
      fieldScore(query, entry.subtitle, 3000),
      fieldScore(query, entry.keywords, 2000),
      fieldScore(query, entry.content, 1000)
    );
  }

  function searchCards(cards, rawQuery) {
    var query = normalize(rawQuery);
    return createIndex(cards)
      .map(function (entry) { return { entry: entry, score: scoreEntry(entry, query) }; })
      .filter(function (match) { return match.score > 0; })
      .sort(function (a, b) { return b.score - a.score || a.entry.card.numero - b.entry.card.numero; })
      .map(function (match) { return match.entry.card; });
  }

  function makeSnippet(card, query) {
    var text = String(card.textoCompleto || '').replace(/\s+/g, ' ').trim();
    var words = text.split(' ');
    var queryToken = normalize(query).split(' ').filter(Boolean)[0];
    var matchIndex = queryToken
      ? words.findIndex(function (word) { return normalize(word).indexOf(queryToken) !== -1; })
      : -1;
    var start = matchIndex > 10 ? matchIndex - 10 : 0;
    var excerpt = words.slice(start, start + 30).join(' ');
    return (start > 0 ? '…' : '') + excerpt + (start + 30 < words.length ? '…' : '');
  }

  function assetUrl(fileName) {
    var base = window.ORACLE_BOOKLET_ASSET_BASE || '';
    try {
      return new URL(fileName, base || window.location.href).href;
    } catch (_error) {
      return fileName;
    }
  }

  function setPageImage(image, source, alt) {
    image.alt = alt;
    image.width = 1100;
    image.height = 1885;
    image.src = assetUrl(source.small);
    image.srcset = assetUrl(source.small) + ' 560w, ' + assetUrl(source.large) + ' 1100w';
    image.sizes = '(min-width: 900px) 45vw, calc(100vw - 60px)';
  }

  function init(root, cards) {
    if (!root || root.dataset.oracleInitialized === 'true') return;
    root.dataset.oracleInitialized = 'true';

    var index = createIndex(cards);
    var searchInput = root.querySelector('[data-ob-search]');
    var clearButton = root.querySelector('[data-ob-clear]');
    var results = root.querySelector('[data-ob-results]');
    var resultsMeta = root.querySelector('[data-ob-results-meta]');
    var empty = root.querySelector('[data-ob-empty]');
    var browse = root.querySelector('[data-ob-browse]');
    var reader = root.querySelector('[data-ob-reader]');
    var backButton = root.querySelector('[data-ob-back]');
    var previousButton = root.querySelector('[data-ob-previous]');
    var nextButton = root.querySelector('[data-ob-next]');
    var shell = root.querySelector('[data-ob-shell]');
    var currentCardIndex = -1;
    var lastTrigger = null;

    function renderResults() {
      var rawQuery = searchInput ? searchInput.value : '';
      var query = normalize(rawQuery);
      var matches = index
        .map(function (entry) { return { entry: entry, score: scoreEntry(entry, query) }; })
        .filter(function (match) { return match.score > 0; })
        .sort(function (a, b) { return b.score - a.score || a.entry.card.numero - b.entry.card.numero; });

      results.textContent = '';
      empty.hidden = matches.length > 0;
      clearButton.hidden = !rawQuery;
      resultsMeta.textContent = matches.length === 1
        ? '1 carta encontrada'
        : matches.length + ' cartas encontradas';

      var fragment = document.createDocumentFragment();
      matches.forEach(function (match) {
        var card = match.entry.card;
        var item = document.createElement('li');
        var button = document.createElement('button');
        button.type = 'button';
        button.className = 'ob-result';
        button.setAttribute('aria-label', 'Abrir ' + card.nome + ', páginas ' + card.paginas.join(' e '));

        if (root.dataset.showThumbnails === 'true') {
          var thumb = document.createElement('img');
          thumb.className = 'ob-result__thumb';
          thumb.src = assetUrl(card.imagens.miniatura);
          thumb.alt = 'Miniatura da carta ' + card.nome;
          thumb.loading = 'lazy';
          thumb.decoding = 'async';
          thumb.width = 220;
          thumb.height = 377;
          button.appendChild(thumb);
        } else {
          var placeholder = document.createElement('span');
          placeholder.className = 'ob-result__thumb ob-result__thumb--empty';
          placeholder.setAttribute('aria-hidden', 'true');
          placeholder.textContent = card.numeroRomano;
          button.appendChild(placeholder);
        }

        var copy = document.createElement('span');
        var number = document.createElement('span');
        var name = document.createElement('span');
        var subtitle = document.createElement('span');
        var excerpt = document.createElement('span');
        number.className = 'ob-result__number';
        name.className = 'ob-result__name';
        subtitle.className = 'ob-result__subtitle';
        excerpt.className = 'ob-result__excerpt';
        number.textContent = card.numeroRomano + ' · páginas ' + card.paginas.join('–');
        name.textContent = card.nome;
        subtitle.textContent = card.subtitulo;
        excerpt.textContent = makeSnippet(card, rawQuery);
        copy.append(number, name, subtitle, excerpt);
        button.appendChild(copy);

        var arrow = document.createElementNS('http://www.w3.org/2000/svg', 'svg');
        arrow.setAttribute('class', 'ob-result__arrow');
        arrow.setAttribute('viewBox', '0 0 24 24');
        arrow.setAttribute('aria-hidden', 'true');
        arrow.innerHTML = '<path d="m9 18 6-6-6-6" fill="none" stroke="currentColor" stroke-width="1.8" stroke-linecap="round" stroke-linejoin="round"/>';
        button.appendChild(arrow);

        button.addEventListener('click', function () {
          lastTrigger = button;
          openCard(card.numero - 1);
        });
        item.appendChild(button);
        fragment.appendChild(item);
      });
      results.appendChild(fragment);
    }

    function openCard(cardIndex) {
      var card = cards[cardIndex];
      if (!card) return;
      currentCardIndex = cardIndex;

      root.querySelector('[data-ob-reader-number]').textContent = card.numeroRomano + ' · páginas ' + card.paginas.join('–');
      root.querySelector('[data-ob-reader-title]').textContent = card.nome;
      root.querySelector('[data-ob-reader-subtitle]').textContent = card.subtitulo;
      setPageImage(
        root.querySelector('[data-ob-page-one]'),
        card.imagens.pagina1,
        'Página ' + card.paginas[0] + ' da carta ' + card.nome
      );
      setPageImage(
        root.querySelector('[data-ob-page-two]'),
        card.imagens.pagina2,
        'Página ' + card.paginas[1] + ' da carta ' + card.nome
      );

      previousButton.disabled = cardIndex === 0;
      nextButton.disabled = cardIndex === cards.length - 1;
      browse.hidden = true;
      reader.hidden = false;
      backButton.focus({ preventScroll: true });
      reader.scrollIntoView({ behavior: 'smooth', block: 'start' });
    }

    function closeReader() {
      reader.hidden = true;
      browse.hidden = false;
      if (lastTrigger && document.contains(lastTrigger)) lastTrigger.focus();
      else if (searchInput) searchInput.focus();
    }

    if (searchInput) {
      searchInput.addEventListener('input', renderResults);
    }

    if (clearButton) {
      clearButton.addEventListener('click', function () {
        searchInput.value = '';
        renderResults();
        searchInput.focus();
      });
    }

    backButton.addEventListener('click', closeReader);
    previousButton.addEventListener('click', function () { openCard(currentCardIndex - 1); });
    nextButton.addEventListener('click', function () { openCard(currentCardIndex + 1); });

    root.querySelectorAll('[data-ob-tab]').forEach(function (tab) {
      tab.addEventListener('click', function () {
        var view = tab.dataset.obTab;
        root.querySelectorAll('[data-ob-tab]').forEach(function (candidate) {
          candidate.setAttribute('aria-selected', candidate === tab ? 'true' : 'false');
        });
        root.querySelectorAll('[data-ob-panel]').forEach(function (panel) {
          panel.hidden = panel.dataset.obPanel !== view;
        });
      });

      tab.addEventListener('keydown', function (event) {
        if (event.key !== 'ArrowLeft' && event.key !== 'ArrowRight') return;
        var tabs = Array.from(root.querySelectorAll('[data-ob-tab]'));
        var current = tabs.indexOf(tab);
        var direction = event.key === 'ArrowRight' ? 1 : -1;
        var target = tabs[(current + direction + tabs.length) % tabs.length];
        event.preventDefault();
        target.focus();
        target.click();
      });
    });

    if (shell) {
      shell.addEventListener('toggle', function () {
        if (shell.open && searchInput && !reader.hidden) return;
        if (shell.open && searchInput && window.matchMedia('(min-width: 750px)').matches) {
          searchInput.focus({ preventScroll: true });
        }
      });
    }

    root.setAttribute('aria-busy', 'false');
    renderResults();
  }

  function waitForData(root) {
    if (window.ORACLE_BOOKLET_CARDS && window.ORACLE_BOOKLET_CARDS.length === 30) {
      init(root, window.ORACLE_BOOKLET_CARDS);
      return;
    }

    var script = root.querySelector('[data-ob-data-script]') || document.querySelector('[data-ob-data-script]');
    if (script && !initializedDataListeners.has(script)) {
      initializedDataListeners.add(script);
      script.addEventListener('load', initAll, { once: true });
      script.addEventListener('error', function () {
        root.setAttribute('aria-busy', 'false');
        var meta = root.querySelector('[data-ob-results-meta]');
        if (meta) meta.textContent = 'Não foi possível carregar o livreto. Atualize a página e tente novamente.';
      }, { once: true });
    }
  }

  function initAll() {
    document.querySelectorAll('[data-oracle-booklet]').forEach(waitForData);
  }

  window.OracleBookletSearch = { initAll: initAll, searchCards: searchCards, normalize: normalize };

  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', initAll);
  else initAll();

  document.addEventListener('shopify:section:load', function (event) {
    var root = event.target.querySelector('[data-oracle-booklet]');
    if (root) waitForData(root);
  });
})();
